module.exports = __webpack_public_path__ + "static/media/alarm-snooze.0493122f.svg";